<template>
  <div>
    <p>Заявление-анкета заемщика <a :href="uiUrl" target="_blank">Открыть документ</a></p>
  </div>
</template>

<script>
export default {
  name: "instCheckBox_AGREEMENT_ANKETA",
  data(){
    return{
      uiUrl:'https://lk.msk.finmoll.com/public/form/' + localStorage.getItem('GUIDeasyConf')
    }
  }
}
</script>

<style scoped>

</style>